module.exports = __webpack_public_path__ + "img/Chart.2dce76eb.png";